import { IconBrandFacebook, IconBrandGithub, IconBrandLinkedin,IconBrandWhatsapp  } from "@tabler/icons-react";
const Info={
    name: "Santosh Acharya",
    stack: ["Software Engineer", "Competitive Programmer", "Freelancer","Mobile App Developer"],
    bio: "Experienced mobile application developer with 2+ years of hands-on experience in designing, developing, and deploying cross-platform mobile applications. Proficient in Dart, Swift, SwiftUI, Flutter, and React Native, with a proven track record of delivering high-quality apps for diverse industries. Skilled in collaborating with cross-functional teams, mentoring junior developers, and driving projects from concept to deployment. Passionate about leveraging cutting-edge technologies to create innovative and user-centric solutions.",

}

const ProjectInfo = [
    {
        title: "Elearning App",
        desc: "Elearning App – A feature-rich learning platform built with Flutter and integrated with a REST API backend, designed to deliver interactive, on-the-go education. The app supports video-based courses, quizzes, progress tracking, and certification—providing learners with a structured and engaging experience. Users can browse courses by category, enroll with one tap, and learn at their own pace with offline support and resume playback. Instructors can manage content, track student performance, and send announcements via a dedicated admin panel. With a clean UI, responsive layout, and scalable architecture, the app delivers a smooth experience across Android and iOS, making education more accessible and flexible than ever.",
        image: "Elearning.png",
        live: false,
        technologies: ["Flutter", "Bloc"],
        link: "https://github.com/santoshacharya07/elearning_app",
        github:"https://github.com/santoshacharya07/elearning_app"
    },
    {
        title: "Food Ordering App",
        desc: "Food Ordering App – A modern, customer-centric mobile application built using Flutter and powered by a REST API backend, designed to offer a seamless food browsing and ordering experience. Users can explore nearby restaurants, view detailed menus with images, customize their meals, and place orders with just a few taps. Real-time order tracking, secure payment integration, and order history enhance convenience and reliability. The app also supports features like promo codes, ratings, and favorite restaurants. Designed with a clean UI and optimized for performance, it delivers a fast and intuitive experience on both Android and iOS devices—bridging the gap between hungry customers and their favorite meals.",
        image: "Food.jpg",
        live: false,
        technologies: ["Flutter", "Provider", "Firebase"],
        link: "https://github.com/santoshacharya07/mynotes",
        github: "https://github.com/santoshacharya07/mynotes"
    },
    {
        title: "Restaurant Management System",
        desc: "Restaurant Management System – A robust, cross-platform mobile application built using Flutter with a REST API backend, designed to modernize and streamline restaurant operations. This all-in-one solution supports real-time order tracking, table management, and digital menu access, while also empowering restaurant staff with features like session start/end, leave requests, and shift tracking. Built with role-based access, it offers tailored interfaces for admins, kitchen staff, and waiters. The backend, powered by RESTful APIs, ensures secure, scalable communication between the app and server, while maintaining fast performance and real-time updates. Designed for both Android and iOS, this system enhances operational efficiency and staff accountability in any restaurant setting.",
        image: "Restaurant.jpg",
        live: false,
        technologies: ["Flutter", "Provider", "Firebase"],
        link: "https://github.com/santoshacharya07/mynotes",
        github: "https://github.com/santoshacharya07/mynotes"
    },
    {
        title: "Meditation App",
        desc: "Meditation App – A full-featured mindfulness and wellness app built using Flutter and Firebase, aimed at helping users reduce stress, sleep better, and stay present through guided meditations and breathing techniques. I led the entire development process—from designing an intuitive UI to integrating backend services like Firebase Auth, Firestore, and Cloud Storage. Key features include audio playback for meditation sessions, customizable sleep sounds, mood tracking, daily reminder notifications, and offline access. The app is optimized for both Android and iOS, with a clean architecture and responsive design that ensures a seamless user experience across devices.",
        image: "Meditation.jpg",
        live: false,
        technologies: ["React", "Tailwind", "Hooks", "Firebase"],
        link: "https://github.com/santoshacharya07/twitter-clone-using-react",
        github: "https://github.com/santoshacharya07/twitter-clone-using-react"
    },
  
]

 const SkillInfo = [
    {
        title: "Frontend",
        skills: ["Flutter", "SwiftUI","React Native","HTML", "CSS", "JavaScript",  "Redux", "Tailwind CSS", "Material UI",
        ]
    },
    {
        title: "Backend",
        skills: ["Node JS", "Express JS", "MySQL", "MongoDB", "Firebase", "PostgresSQL"]
    },
    {
        title: "Languages",
        skills: ["Dart", "Swift","C", "C++", "Java", "JavaScript"]
    },
    {
        title: "Tools",
        skills: ["Git", "Github", "VS Code", "Postman", "MongoDB Compass", "Android Studio", "Xcode"]
    },
    {
        title: "Platforms",
        skills: ["App Store", "Play Store"]
    }
]

const ExperienceInfo = [
    {
        role: "Mobile Application Developer",
        company: "QB Tech",
        date: "April 2023 - Present",
        desc: "At QB Tech, I work as a mobile application developer with a primary focus on Flutter for building high-performance, cross-platform applications. My role involves the full development lifecycle—from gathering client requirements and designing intuitive UI/UX to implementing scalable features and deploying polished applications on both Android and iOS platforms. I collaborate with cross-functional teams to ensure seamless integration with backend services, optimize performance, and maintain clean, maintainable code. I also contribute to architectural decisions, API integrations, and the adoption of modern development practices to ensure project success.",
        skills: ["React JS","Flutter", "SwiftUI", "Node JS", "MySQL", "MongoDB", "Microservices"]
    },
    {
        role: "Mobile Application Developer",
        company: "Freelancer",
        date: "February 2022 – March 2023",
        desc: "As a freelance Flutter developer, I specialize in creating cross-platform mobile applications using the Flutter framework. My role involves working directly with clients to gather requirements, design UI/UX interfaces, implement features, and ensure high performance across both Android and iOS platforms. I focus on delivering clean, maintainable code and seamless user experiences.",
        skills: ["Flutter", "SwiftUI", "Bloc", "Provider",]
    }
]
const Slugs = [
    "typescript",
    "javascript",
    "dart",
    "java",
    "react",
    "flutter",
    "android",
    "html5",
    "css3",
    "mongodb",
    "nodedotjs",
    "express",
    "mysql",
    "amazonaws",
    "postgresql",
    "firebase",
    "git",
    "jira",
    "github",
    "gitlab",
    "visualstudiocode",
    "androidstudio",
    "xcode",
    "figma",
]
const socialLinks = [
    { link: "https://github.com/santoshacharya07", icon: IconBrandGithub },
    { link: "https://wa.me/9779843609507", icon: IconBrandWhatsapp },
    { link: "https://www.linkedin.com/in/santosh747/", icon: IconBrandLinkedin },
    { link: "https://www.facebook.com/santosh.acharya007", icon: IconBrandFacebook }

]

export {Info, ProjectInfo,SkillInfo, ExperienceInfo, Slugs,socialLinks };